import { CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import React from 'react'
import CruiseInclusionList from 'components/Cruises/CruiseInclusion/CruiseInclusionList'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { getOptimizelyEnabledDecision } from 'lib/optimizely/optimizelyUtils'

interface Props {
  view: CruiseOfferView
  filters?: App.OfferListFilters
}

function CruiseSearchTileFeatures({ view }: Props) {
  // TODO: Remove this once the A/B test is complete https://aussiecommerce.atlassian.net/browse/CRUZ-3360
  const cruiseSearchTileRedesignEnabled = getOptimizelyEnabledDecision(
    useOptimizelyExperiment(OptimizelyExperiments.cruiseSearchTileRedesign),
  )

  return <CruiseInclusionList
    offer={view.offer as App.CruiseOffer}
    evergreenInclusions={view.evergreenInclusions}
    tileInclusions={view.tileInclusions}
    standardInclusions={view.standardInclusions}
    luxPlusInclusions={view.luxPlusInclusions}
    enableRedesignVariant={cruiseSearchTileRedesignEnabled}
  />
}

export default CruiseSearchTileFeatures
